export var atomicMapSlider = {
    slider: ['relative', 'h-px-12', 'cursor-pointer', 'box-border', 'py-px-4'],
    rail: ['absolute', 'h-px-8', 'rounded-md', 'w-full'],
    handlerStyle: [
        'absolute',
        'w-px-14',
        'h-px-14',
        'cursor-pointer',
        'bg-white',
        'border-2',
        'border-solid',
        'border-brand-600',
        '-translate-y-1/2',
        'rounded-half',
    ],
    trackStyle: ['absolute', 'h-px-8', 'rounded-md', 'bg-brand-600'],
};
export var atomicMapHandle = {};
